import jMoment from 'jalali-moment';
export default function firstAndEndOfMonth(jalaliYear:string, jalaliMonth:string) {
  // First day of the Jalali month
  const firstDayJalali = jMoment(`${jalaliYear}/${jalaliMonth}/01`, 'jYYYY/jMM/jDD');
  
  // Last day of the Jalali month
  const lastDayJalali = firstDayJalali.clone().endOf('jMonth');

  // Convert to Gregorian and format as ISO 8601 (e.g., 2024-08-20T00:00:00.0Z)
  const firstDayGregorian = firstDayJalali.clone().subtract(2, 'days').format('YYYY-MM-DD[T]00:00:00.0[Z]');
  const lastDayGregorian = lastDayJalali.clone().add(2, 'days').format('YYYY-MM-DD[T]00:00:00.0[Z]');

  return {
    firstDay: firstDayGregorian,
    lastDay: lastDayGregorian
  };
}

// Example usage
// const { firstDay, lastDay } = firstAndEndOfMonth(1402, 7);
// console.log('First Day:', firstDay);
// console.log('Last Day:', lastDay);
